import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { LoadingWrapper, StyledLottie, TextWrapper, TitleText } from './LoadingFinalStep.styles';

import LOADING_CONTRACT_LOTTIE from '@/assets/lotties/loading_contract.json';
import { useWelcomeModalStore } from '@/hooks/useWelcomeModal';
import { useUserOnboarding, useMutateUserOnboarding, useProfile } from '@/store';

const MIN_LOADING_TIME = 3000;
const POLLING_INTERVAL = 1000;

export const LoadingFinalStep = () => {
  const { t } = useTranslation('StudentOnboardingPageTranslations');
  const { markContractAsSigned, finishUserOnboarding } = useMutateUserOnboarding();
  const { refetch: refetchProfile } = useProfile();
  const { userOnboarding: onboarding, refetch: refetchOnboarding } = useUserOnboarding();
  const [isLoading, setIsLoading] = useState(true);
  const [hasUpdatedContract, setHasUpdatedContract] = useState(false);
  const { openModal } = useWelcomeModalStore();

  const navigateTo = useNavigate();

  const handleContractUpdate = () => {
    if (!hasUpdatedContract) {
      setHasUpdatedContract(true);
      markContractAsSigned(undefined, {
        onSuccess: () => {
          finishUserOnboarding();
          refetchProfile();
          refetchOnboarding();
          openModal();
          navigateTo('/dashboard');
        }
      });
    }
  };
  useEffect(() => {
    const pollingInterval = setInterval(async () => {
      await refetchOnboarding();
      if (onboarding?.contract?.contractFile) {
        clearInterval(pollingInterval);
      }
    }, POLLING_INTERVAL);

    const minLoadingTimer = setTimeout(() => {
      if (onboarding?.contract?.contractFile) {
        clearInterval(pollingInterval);
      }
      setIsLoading(false);
    }, MIN_LOADING_TIME);

    return () => {
      clearInterval(pollingInterval);
      clearTimeout(minLoadingTimer);
    };
  }, [onboarding?.contract?.contractFile, refetchOnboarding]);

  useEffect(() => {
    const contractCorrect = onboarding?.contract?.contractFile;
    const notProd = !import.meta.env.PROD;
    const finishLoading = !isLoading && (contractCorrect || notProd);
    if (finishLoading) {
      handleContractUpdate();
    }
  }, [isLoading, onboarding?.contract?.contractFile]);

  return (
    <LoadingWrapper>
      <StyledLottie animationData={LOADING_CONTRACT_LOTTIE} autoPlay loop />
      <TextWrapper>
        <TitleText>{t('LOADING_APP_TITLE')}</TitleText>
        <span>{t('LOADING_APP_DESCRIPTION')}</span>
      </TextWrapper>
    </LoadingWrapper>
  );
};
